import EditorTabs from 'components/DocumentDetail/Editor/EditorTabs'
import { DocumentOrderForm } from 'entities/DocumentsOrderForm'

import Base from './Base'
import Items from './Items'

interface Props {
  docDetail: DocumentOrderForm
}

function OrderForm({ docDetail }: Props) {
  return (
    <EditorTabs labels={['基本情報', '品目情報']}>
      <Base docDetail={docDetail} />
      <Items docDetail={docDetail} />
    </EditorTabs>
  )
}

export default OrderForm
